import { DeviceDomainService } from './domain';
import { DeviceFactory } from './entity/deviceFactory';
import { DeviceInfoFactory } from './entity/deviceInfoFactory';

import type { DeviceIRepository } from './entity/deviceIRepository';
import type { Logger } from '@/infra/logger';
import type { DeviceJson } from '@/types/domain/device/entities/deviceEntity';

/**
 * デバイスアプリケーションサービス
 */
export class DeviceApplicationService {
  private service!: DeviceDomainService;

  private deviceFactory = new DeviceFactory();

  private deviceInfoFactory = new DeviceInfoFactory();

  /**
   * Injection
   * @param deviceRepository deviceRepository
   * @param logger logger
   */
  public inject(
    deviceRepository: DeviceIRepository,
    logger: Logger,
  ) {
    this.service = new DeviceDomainService(logger);
    this.service.inject(deviceRepository);
  }

  /**
   * トークンリスト取得
   * @returns リスト
   */
  async getTokenList() {
    const tokenList = await this.service.getTokenList();
    return tokenList;
  }

  /**
   * デバイス作成
   * @param input input
   * @returns 結果
   */
  async createDevice(input: DeviceJson) {
    const entity = this.deviceFactory.createFromJsonPvt(input);
    const result = await this.service.createDevice(entity);
    return result;
  }

  /**
   * デバイス削除
   * @param input input
   * @returns 結果
   */
  async deleteDevice(input: DeviceJson) {
    const entity = this.deviceFactory.createFromJsonPvt(input);
    const result = await this.service.deleteDevice(entity);
    return result;
  }

  /**
   * window.navigatorからデバイス情報を取得する.
   * @returns デバイス情報Entity
   */
  public getDeviceInfo() {
    const entity = this.deviceInfoFactory.createFromWindowNavigator();
    return entity.toJsonData();
  }
}
